<template>
    <div>
        <van-form  @submit="onSubmit">
            <van-field
                    name="downInfoId"
                    v-model="formData.downInfoId"
                    style="display: none"
            />
    <van-collapse v-model="subActivate" @change="collapseChange" :accordion="true" >
        <van-collapse-item title="下家信息">
            <van-field
                    label="下家单位名称:"
                    placeholder="请输入下家单位名称"
                    label-width="100px"
                    input-align="left"
                    name="unitName"
                    v-model="formData.unitName"
                    :rules="[{ required: true, message: '请输入下家单位名称' }]"
            />
            <van-field
                    readonly
                    clickable
                    name="downNature"
                    :value="formData.downNature"
                    label="下家性质:"
                    placeholder="点击选择"
                    label-width="100px"
                    input-align="left"
                    @click=" showPicker = true"
                    :rules="[{ required: true, message: '请选择下家性质' }]"
            />
            <van-popup v-model="showPicker" position="bottom">
                <van-picker
                        show-toolbar
                        :columns="upperNatures"
                        @confirm="onConfirm"
                        @cancel="showPicker = false"
                />
            </van-popup>
            <van-field v-if="downNatureShow"
                    label="批贷类型:"
                    label-width="100px"
                    input-align="left"
                    name="loanType"
                    readonly
                    :rules="[{ required: true, message: '请选择' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.loanType" direction="horizontal" >
                        <van-radio name="个人消费贷">个人消费贷</van-radio>
                        <van-radio name="个人经营贷">个人经营贷</van-radio>
                        <van-radio name="企业经营贷">企业经营贷</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field
                    label="下家地址:"
                    placeholder="请输入下家地址"
                    label-width="100px"
                    input-align="left"
                    name="contactAddress"
                    v-model="formData.contactAddress"
                    :rules="[{ required: true, message: '请输入下家地址' }]"
            />
            <van-field
                    label="联系人姓名:"
                    placeholder="请输入联系人姓名"
                    label-width="100px"
                    input-align="left"
                    name="contactName"
                    v-model="formData.contactName"
                    :rules="[{ required: true, message: '请输入联系人姓名' }]"
            />
            <van-field
                    label="联系方式:"
                    placeholder="请输入联系方式"
                    label-width="100px"
                    input-align="left"
                    name="contractPhone"
                    v-model="formData.contractPhone"
                    :rules="[{ required: true, message: '请输入联系方式' }]"
            />
        </van-collapse-item>
        <van-collapse-item title="批贷信息">
            <van-field
                    label="是否已批贷:"
                    label-width="100px"
                    input-align="left"
                    name="approve"
                    readonly
                    :rules="[{ required: true, message: '请选择是否已批贷' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.approve" direction="horizontal" >
                        <van-radio name="是">是</van-radio>
                        <van-radio name="否"><span style="color: red">否</span></van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field
                    label="下家机构的所有借款人姓名:"
                    label-width="100px"
                    input-align="left"
                    name="customerNameSame"
                    readonly
                    :rules="[{ required: true, message: '请选择' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.customerNameSame" direction="horizontal"  @change="onCustomerNameSameSelect">
                        <van-radio name="与上家所有借款人一致">与上家所有借款人一致</van-radio>
                        <van-radio name="与上家所有借款人不一致"><span style="color: red">与上家所有借款人不一致</span></van-radio>
                    </van-radio-group>
                </template>
            </van-field>

            <van-field v-if="customerNameSameShow"
                    label="不一致的原因表述:"
                    placeholder="请输入不一致的原因表述"
                    label-width="100px"
                    input-align="left"
                    name="customerNameDif"
                    v-model="formData.customerNameDif"
                    :rules="[{ required: true, message: '请输入不一致的原因表述' }]"
            />
            <van-field v-if="customerNameSameShow"
                    label="全部借款人姓名:"
                    placeholder="请输入全部借款人姓名"
                    label-width="100px"
                    input-align="left"
                    name="customerName"
                    v-model="formData.customerName"
                    :rules="[{ required: true, message: '请输入全部借款人姓名' }]"
            />

            <van-field
                    label="抵押物是否与我司借款申请一致:"
                    label-width="100px"
                    input-align="left"
                    name="mortgageSame"
                    readonly
                    :rules="[{ required: true, message: '请选择' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.mortgageSame" direction="horizontal" >
                        <van-radio name="是">是</van-radio>
                        <van-radio name="否"><span style="color: red">否</span></van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field
                    label="批贷日期:"
                    clickable
                    :value="formData.approveDate"
                    @click.native.stop="upperDueDateShow = true"
                    readonly
                    name="approveDate"
                    :rules="[{ required: true, message: '请选择批贷日期' }]"
            >
            </van-field>
            <van-calendar v-model="upperDueDateShow" :max-date="maxDate" @confirm="onUpperDueDateConfirm" />


            <van-field
                    label="批贷金额(元):"
                    clickable
                    name="approveAmount"
                    :value="formData.approveAmount"
                    @click.native.stop="principalShow = true"
                    :rules="[{ required: true, message: '请输入批贷金额' }]"
                    readonly
            >
            </van-field>

            <van-number-keyboard
                    :show="principalShow"
                    extra-key="."
                    close-button-text="完成"
                    @blur="principalShow = false"
                    v-model="formData.approveAmount"
            />

            <van-field
                    label="批贷期限（月）:"
                    placeholder="请输入批贷期限"
                    label-width="100px"
                    input-align="left"
                    name="approveNo"
                    v-model="formData.approveNo"
                    :rules="[{ required: true, message: '请输入批贷期限' }]"
            />

            <van-field
                    label="批贷利率(%):"
                    clickable
                    name="approveRate"
                    :value="formData.approveRate"
                    @click.native.stop="interestShow = true"
                    :rules="[{ required: true, message: '请输入批贷利率' }]"
                    readonly
            >
            </van-field>

            <van-number-keyboard
                    :show="interestShow"
                    extra-key="."
                    close-button-text="完成"
                    @blur="interestShow=false"
                    v-model="formData.approveRate"
            />
            <van-field
                    label="是否带条件审批:"
                    label-width="100px"
                    input-align="left"
                    name="hasCondition"
                    readonly
                    :rules="[{ required: true, message: '请选择' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.hasCondition" direction="horizontal" @change="onHasConditionSelect">
                        <van-radio name="是">是</van-radio>
                        <van-radio name="否">否</van-radio>
                    </van-radio-group>
                </template>
            </van-field>

            <van-field  v-if="hasConditionShow"
                    label="审批条件:"
                    placeholder="请输入审批条件"
                    label-width="100px"
                    input-align="left"
                    name="approveCondition"
                    v-model="formData.approveCondition"
                    :rules="[{ required: true, message: '请输入审批条件' }]"
            />

            <van-field
                       label="是否需要公证:"
                       label-width="100px"
                       input-align="left"
                       name="hasNotary"
                       readonly
                       :rules="[{ required: true, message: '请选择' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.hasNotary" direction="horizontal" @change="onHasNotarySelect">
                        <van-radio name="是">是</van-radio>
                        <van-radio name="否">否</van-radio>
                    </van-radio-group>
                </template>
            </van-field>

            <van-field v-if="hasNotaryShow"
                    label="当前是否做过公证:"
                    label-width="100px"
                    input-align="left"
                    name="notaried"
                    readonly
                    :rules="[{ required: true, message: '请选择' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.notaried" direction="horizontal" >
                        <van-radio name="是">是</van-radio>
                        <van-radio name="否">否</van-radio>
                    </van-radio-group>
                </template>
            </van-field>

            <van-field v-if="hasNotaryShow"
                       label="公证书是否已出:"
                       label-width="100px"
                       input-align="left"
                       name="notariedBook"
                       readonly
                       :rules="[{ required: true, message: '请选择' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.notariedBook" direction="horizontal" >
                        <van-radio name="是">是</van-radio>
                        <van-radio name="否">否</van-radio>
                    </van-radio-group>
                </template>
            </van-field>

            <van-field
                    readonly
                    clickable
                    name="loanCondition"
                    :value="formData.loanCondition"
                    label="放款条件:"
                    placeholder="点击选择"
                    label-width="100px"
                    input-align="left"
                    :rules="[{ required: true, message: '请选择放款条件' }]"
                    @click="showLoanCondition = true"

            />
            <van-popup v-model="showLoanCondition" position="bottom">
                <van-cell
                        title="已选择"
                        left>
                    <template>
                        <van-tag plain round closeable type="success"  size="medium"  v-for="(item,index) in loanConditionSelected" :key="index" @close="onConditionClose(item)" @click="onConditionClose(item)">{{item}}</van-tag>
                    </template>
                </van-cell>

                <van-picker
                        show-toolbar
                        :columns="loanConditions"
                        @confirm="onLoanConditionConfirm"
                        @cancel="showLoanCondition = false"
                        @change="onLoanConditionChange"
                />
            </van-popup>

        </van-collapse-item>
        <van-collapse-item title="三方账户信息">
            <van-field
                    label="下家的放款账户是否已提供:"
                    label-width="100px"
                    input-align="left"
                    name="accountProvide"
                    readonly
                    :rules="[{ required: true, message: '请选择' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.accountProvide" direction="horizontal" @change="onAccountProvideSelect">
                        <van-radio name="是">是</van-radio>
                        <van-radio name="否">否</van-radio>
                    </van-radio-group>
                </template>
            </van-field>

            <van-field
                    label="下家放款账户类型:"
                    label-width="100px"
                    input-align="left"
                    name="accountType"
                    readonly
                    :rules="[{ required: true, message: '请选择' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.accountType" direction="horizontal" >
                        <van-radio name="借款人账户">借款人账户</van-radio>
                        <van-radio name="三方对公账户">三方对公账户</van-radio>
                        <van-radio name="三方个人账户">三方个人账户</van-radio>
                    </van-radio-group>
                </template>
            </van-field>

            <v-template v-if="accountProvideShow">
                <van-field  v-if="hasConditionShow"
                            label="下家放款账户户名:"
                            placeholder="请输入下家放款账户户名"
                            label-width="100px"
                            input-align="left"
                            name="bankAccountName"
                            v-model="formData.bankAccountName"
                            :rules="[{ required: true, message: '请输入下家放款账户户名' }]"
                />
                <van-field  v-if="hasConditionShow"
                            label="下家放款账户账号:"
                            placeholder="请输入下家放款账户账号"
                            label-width="100px"
                            input-align="left"
                            name="bankAccount"
                            v-model="formData.bankAccount"
                            :rules="[{ required: true, message: '请输入下家放款账户账号' }]"
                />
                <van-field  v-if="hasConditionShow"
                            label="下家放款账户开户行:"
                            placeholder="请输入下家放款账户开户行"
                            label-width="100px"
                            input-align="left"
                            name="bankName"
                            v-model="formData.bankName"
                            :rules="[{ required: true, message: '请输入下家放款账户开户行' }]"
                />

            </v-template>

            <van-field
                        label="三方过账要求:"
                        placeholder="请输入三方过账要求"
                        label-width="100px"
                        input-align="left"
                        name="thirdRequire"
                        v-model="formData.thirdRequire"
                        :rules="[{ required: true, message: '请输入三方过账要求' }]"
            />
        </van-collapse-item>

        <van-collapse-item title="下家交接信息">
            <van-field
                    label="进抵方式:"
                    label-width="100px"
                    input-align="left"
                    name="advanceMode"
                    readonly
                    :rules="[{ required: true, message: '请选择' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.advanceMode" direction="horizontal" >
                        <van-radio name="陪同房管局抵押">陪同房管局抵押</van-radio>
                        <van-radio name="系统线上抵押">系统线上抵押</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field
                    label="下家是否收押房本:"
                    label-width="100px"
                    input-align="left"
                    name="collectProperty"
                    readonly
                    :rules="[{ required: true, message: '请选择' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.collectProperty" direction="horizontal">
                        <van-radio name="是">是</van-radio>
                        <van-radio name="否">否</van-radio>
                    </van-radio-group>
                </template>
            </van-field>

            <van-field
                    label="进抵后预计放款时间:"
                    placeholder="请输入进抵后预计放款时间"
                    label-width="100px"
                    input-align="left"
                    name="advanceDate"
                    v-model="formData.advanceDate"
                    :rules="[{ required: true, message: '请输入进抵后预计放款时间' }]"
            />
            <van-field
                    label="下家配合度:"
                    label-width="100px"
                    input-align="left"
                    name="cooperationDegree"
                    readonly
                    :rules="[{ required: true, message: '请选择' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.cooperationDegree" direction="horizontal" >
                        <van-radio name="高">高</van-radio>
                        <van-radio name="一般">一般</van-radio>
                        <van-radio name="不愿配合">不愿配合</van-radio>
                    </van-radio-group>
                </template>
            </van-field>

            <van-field
                       readonly
                       clickable
                       name="sourceCheck"
                       :value="formData.sourceCheck"
                       label="信息来源核对:"
                       placeholder="点击选择"
                       label-width="100px"
                       input-align="left"
                       :rules="[{ required: true, message: '请选择信息来源核对' }]"
                       @click="showSourceCheck = true"

            />
            <van-popup v-model="showSourceCheck" position="bottom">
                <van-cell
                        title="已选择"
                        left>
                    <template>
                        <van-tag plain round closeable type="success"  size="medium"  v-for="(item,index) in sourceCheckSelected" :key="index" @close="onClose(item)" @click="onClose(item)">{{item}}</van-tag>
                    </template>
                </van-cell>

                <van-picker
                        show-toolbar
                        :columns="sourceChecks"
                        @confirm="onSourceCheckConfirm"
                        @cancel="showSourceCheck = false"
                        @change="onSourceCheckChange"
                />
            </van-popup>
            <van-field
                    label="补充说明:"
                    placeholder="补充说明"
                    label-width="100px"
                    input-align="left"
                    name="otherRemark"
                    v-model="formData.otherRemark"
            />
        </van-collapse-item>
        <van-collapse-item title="下家影像资料">
            <!--<FilesUpload style="margin-top: 10px;" :applyId="applyId" :groupCode="902" refName="downBank" :isUpload="true"></FilesUpload>-->
            <oss-upload style="margin-top: 10px;" :applyId="applyId" :groupCode="902" refName="downBank" :isUpload="true"></oss-upload>
        </van-collapse-item>
    </van-collapse>


    <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit" :loading="loading">
            保存
        </van-button>
    </div>
        </van-form>
    </div>
</template>

<script>
    import {saveDownBank,findDownBank} from '@/api/foreclosure'
    import { uuid } from '@/vue/utils/util'
    import FilesUpload from '../../business/mortgage/files-upload'
    import Vue from 'vue'
    import { Toast } from 'vant'
    Vue.use(Toast)
    import { debounce,cloneDeep } from 'lodash'
    import ossUpload from '@/views/component/oss-upload'
    export default {
        name: 'down_bank_edit',
        components: {
            FilesUpload,
            ossUpload
        },
        props: {
            applyId: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                formData:{},
                subActivate: [],
                loading:false,
                customerNameSameShow:false,
                hasConditionShow:false,
                hasNotaryShow:false,
                showLoanCondition:false,
                loanConditionSelected:[],
                loanConditions:['无','见他项','见回执','交保证金','买保险','买贵金属','见保函','其他'],
                accountProvideShow:false,
                showPicker:false,
                upperNatures:['个人','机构','银行'],
                sourceChecks:['经办口述','系统核对'],
                principalShow:false,
                interestShow:false,
                upperDueDateShow:false,
                showSourceCheck:false,
                downNatureShow:false,
                sourceCheckSelected:[],
                maxDate: new Date(2050, 11, 31),
            }
        },
        mounted() {
            this.loadData()
        },
        methods: {
            collapseChange(array) {
            },
            onCustomerNameSameSelect(value){
                this.customerNameSameShow=(value=='与上家所有借款人不一致')
            },
            //是否带条件审批
            onHasConditionSelect(value,option){
                this.hasConditionShow=(value=='是')
            },
            onHasNotarySelect(value){
                this.hasNotaryShow=(value=='是')
            },
            //下家的放款账户是否已提供
            onAccountProvideSelect(value,option){
                this.accountProvideShow=(value=='是')
            },
            //日期格式化
            formatDate(date) {
                var ft=Vue.filter('dateYmdFormat')
                return ft(date)
            },
            onConfirm(value){
                this.formData.downNature = value;
                this.showPicker = false;
                this.downNatureShow=(value=='银行')
            },
            onUpperDueDateConfirm(date){
                this.upperDueDateShow = false;
                this.formData.approveDate = this.formatDate(date);
            },
            onClose(value){
                if(this.sourceCheckSelected.includes(value))
                    this.sourceCheckSelected.splice(this.sourceCheckSelected.findIndex(item => item===value), 1)
            },
            onConditionClose(value){
                if(this.loanConditionSelected.includes(value))
                    this.loanConditionSelected.splice(this.loanConditionSelected.findIndex(item => item===value), 1)
            },
            onSourceCheckConfirm(value,index){
                this.formData.sourceCheck = this.sourceCheckSelected.join(",");
                this.showSourceCheck = false;
            },
            onLoanConditionConfirm(value,index){
                this.formData.loanCondition = this.loanConditionSelected.join(",");
                this.showLoanCondition = false;
            },
            onSourceCheckChange(picker, value, index){
                if(!this.sourceCheckSelected.includes(value))
                    this.sourceCheckSelected.push(value)
            },
            onLoanConditionChange(picker, value, index){
                if(!this.loanConditionSelected.includes(value))
                    this.loanConditionSelected.push(value)
            },
            onSubmit(values){
                let self=this
                let params=cloneDeep(values)
                params=Object.assign(self.formData,params)
                if(params.downInfoId==null){
                    const downInfoId=uuid()
                    params.downInfoId=downInfoId
                }
                params.applyId=self.applyId
                self.loading=true
                saveDownBank(params).then(res => {
                    if(res.success){
                        Toast.success(res.msg);
                    }else{
                        Toast.fail(res.msg);
                    }
                    this.loading=false
                })
            },
            loadData(){
                let self=this
                findDownBank({applyId:self.applyId}).then(res => {
                    if(res.success){
                        let downBank=res.data
                        let formData=cloneDeep(downBank)
                        //日期处理
                        formData.approveDate!=null?(formData.approveDate = this.formatDate(formData.approveDate)):''
                        //显示字段处理
                        self.downNatureShow=(formData.downNature=='银行')
                        self.customerNameSameShow=(formData.customerNameSame=='与上家所有借款人不一致')
                        self.hasConditionShow=(formData.hasCondition=='是')
                        self.hasNotaryShow=(formData.hasNotary=='是')
                        self.accountProvideShow=(formData.accountProvide=='是')
                        //数值处理
                        formData.approveRate=formData.approveRate!=null?(formData.approveRate.toString()):''
                        formData.approveAmount=formData.approveAmount!=null?(formData.approveAmount.toString()):''
                        //多选处理
                        self.sourceCheckSelected=(formData.sourceCheck!=null?formData.sourceCheck.split(","):[])
                        self.loanConditionSelected=(formData.loanCondition!=null?formData.loanCondition.split(","):[])
                        debounce(() => {
                            this.formData=formData
                        }, 1000)()
                    }
                })
            }

        }
    }
</script>

<style scoped>

</style>
